import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from 'services/baseQuery';

export const usersApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'usersApi',
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (params) => ({
        url: '/users',
        method: 'GET',
        params,
      }),
    }),
    getUsersUnpage: builder.query({
      query: (params) => ({
        url: '/users_unpaging',
        method: 'GET',
        params,
      }),
    }),
    getDetailUser: builder.query({
      query: ({ id, params }) => ({
        url: '/users/' + id,
        method: 'GET',
        params
      })
    }),
    deleteUser: builder.mutation({
      query: ({ body, id }) => ({
        url: `/users/deactivate/${id}`,
        method: 'PATCH',
        body,
      })
    }),
    createUpdateUser: builder.mutation({
      query: ({ body, id }) => ({
        url: '/users' + (id ? `/${id}` : ''),
        method: id ? 'PATCH' : 'POST',
        body: {
          user: body
        }
      })
    }),
    sendInfoLogin: builder.mutation({
      query: (id) => ({
        url: `/auth/confirm_code_user/${id}`,
        method: 'GET',
      })
    }),
  }),
  
});

export const { 
  usePrefetch,
  useGetUsersQuery,
  useLazyGetUsersUnpageQuery,
  useGetDetailUserQuery,
  useDeleteUserMutation,
  useCreateUpdateUserMutation,
  useSendInfoLoginMutation
} = usersApi;
